/**
 * @file syncActions.js
 * @location src/store/reducers/syncActions.js
 * @role Supabase 하이드레이션 + Realtime 반영 리듀서 (사용자 액션 아님 — 동기화 전용)
 *
 *  HYDRATE              로그인 후 팀 데이터로 tasks/deletedTasks/members/templates/회사명/uid 교체
 *  SYNC_TASK_UPSERT     Realtime/낙관적 재조정 — id 기준 교체. deletedAt 유무로 버킷 분리
 *  SYNC_TASK_REMOVE     영구 삭제 반영 (양 버킷에서 제거)
 *  SYNC_MEMBER_UPSERT / _REMOVE
 *  SYNC_TEMPLATE_UPSERT / _REMOVE
 *
 *  upsert = id 일치 시 교체, 없으면 추가 (멱등 — 자기 자신의 낙관적 변경도 안전하게 흡수).
 *  (분류 전체는 integrations/supabase/sync.js 카탈로그 참조 — 이 파일은 realtime/HYDRATE 수신 리듀서 전용)
 */

function upsertById(list, item) {
  const i = (list ?? []).findIndex(x => x.id === item.id);
  if (i === -1) return [...(list ?? []), item];
  const next = [...list];
  next[i] = item;
  return next;
}

const removeById = (list, id) => (list ?? []).filter(x => x.id !== id);

export const syncActions = {
  HYDRATE: (state, action) => ({
    ...state,
    uid:           action.payload.uid ?? state.uid,
    members:       action.payload.members ?? state.members,
    tasks:         action.payload.tasks ?? [],
    deletedTasks:  action.payload.deletedTasks ?? [],
    taskTemplates: action.payload.taskTemplates ?? [],
    companyName:   action.payload.companyName ?? state.companyName,
    subscription:  action.payload.subscription ?? state.subscription,
    onboarded:     true,
  }),

  SYNC_TASK_UPSERT: (state, action) => {
    const t = action.task;
    if (t.deletedAt) {
      return {
        ...state,
        tasks: removeById(state.tasks, t.id),
        deletedTasks: upsertById(state.deletedTasks, t),
      };
    }
    return {
      ...state,
      tasks: upsertById(state.tasks, t),
      deletedTasks: removeById(state.deletedTasks, t.id),
    };
  },

  SYNC_TASK_REMOVE: (state, action) => ({
    ...state,
    tasks: removeById(state.tasks, action.id),
    deletedTasks: removeById(state.deletedTasks, action.id),
  }),

  SYNC_MEMBER_UPSERT: (state, action) => ({
    ...state, members: upsertById(state.members, action.member),
  }),
  SYNC_MEMBER_REMOVE: (state, action) => ({
    ...state, members: removeById(state.members, action.id),
  }),

  SYNC_TEMPLATE_UPSERT: (state, action) => ({
    ...state, taskTemplates: upsertById(state.taskTemplates, action.template),
  }),
  SYNC_TEMPLATE_REMOVE: (state, action) => ({
    ...state, taskTemplates: removeById(state.taskTemplates, action.id),
  }),
};
